<template>
  <div>
    <List
      url="device-monitor/result/"
      :title="title"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :operat="operation"
      :update="updateList"
      :MultipleSel="true"
      @edit="edit"
      @deletedata="deletedata"
    >
      <div slot="Filter">
      <el-row :gutter="20">
        <el-col :span="24" style="margin-left:10px;margin-bottom:20px;">
          <label>监控设备：</label>
          <el-select multiple v-model="selectDevices" placeholder="选择监控设备(多选)" style="width:300px;margin-right:10px;" size="small">
            <el-option
              v-for="device in monitorDevices"
              :label="device"
              :key="device"
              :value="device"></el-option>
          </el-select>

          <label>云平台：</label>
          <el-select multiple v-model="selectClouds" placeholder="选择云平台(多选)" style="width:216px;margin-right:10px;" size="small">
            <el-option
              v-for="cloud in cloudEnvList"
              :label="cloud"
              :key="cloud"
              :value="cloud"></el-option>
          </el-select>

          <el-button @click="search" type="primary" size="small" style="margin-right:10px;">Search</el-button>
          <el-button @click="statistics" type="primary" size="small" style="margin-right:10px;">监控数据图表</el-button>

        </el-col>

        <el-col :span="24" style="margin-left:10px;margin-bottom:20px;">
          <label>设备mac：</label>
          <el-input
            v-model="searchData.mac"
            size="small"
            style="width:200px;margin-right:10px;"
            placeholder="请输入设备MAC"
          ></el-input>

          <label>监控指标：</label>
          <el-input
            v-model="searchData.metric"
            size="small"
            style="width:200px;margin-right:10px;"
            placeholder="请输入指标key (多个用英文逗号隔开)"
          ></el-input>
        </el-col>
      </el-row>
      </div>

      <div slot="Fresh" style="float:right;">
        <el-button @click="updateList++" type="primary" size="small">刷新列表</el-button>
      </div>
    </List>
  </div>
</template>

<script>
import List from "../components/common/List.vue";

export default {
  components: {
    List
  },
  data() {
    return {
      monitorDevices: [],
      selectDevices: [],
      cloudEnvList: [],  // 从后端获取的 cloud 列表
      selectClouds: [],
      title: "设备监控-监控结果",
      tanle: [
        { name: "create_time", label: "时间" },
        { name: "device_type", label: "设备类型" },
        { name: "device_model", label: "设备型号" },
        { name: "device_name", label: "设备名称" },
        { name: "mac", label: "设备MAC" },
        { name: "cloud", label: "云平台" },
        { name: "firmware_version", label: "固件版本" },
        { name: "metric", label: "监控指标" },
        { name: "value", label: "监控数据" }
      ],
      searchData: {
        device_name: "",
        cloud: "",
        mac: "",
        metric: ""
      },
      operation: [
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],
      updateList: 0,
      updateForm: {},
      updateType: "edit",
      updateBlock: false,
      token: ""
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.fetchMonitorTasks();
    this.fetchCloudEnvs();
    this.fetchDeviceMonitorMetrics();
  },
  methods: {
    statistics(){
      window.open("http://grafana.akuvox.com/d/db19461e-2812-42db-bbbb-3ed3ea9b8159/e8aebe-e5a487-e79b91-e68ea7");
    },
    dealList(data) {
      for (let i in data) {
        data[i].create_time = this.changeDate(data[i].create_time);
      }
      return data;
    },
    close() {
      this.updateBlock = false;
    },
    add() {
      this.updateType = "add";
      this.updateForm = {};
      this.updateBlock = true;
    },
    edit(val) {
      this.updateType = "edit";
      this.updateForm = Object.assign({}, val);
      this.updateBlock = true;
    },
    search() {
      this.searchData.device_name = this.selectDevices.join(",");
      this.searchData.cloud = this.selectClouds.join(",");
      this.updateList++;
    },
    deletedata(val) {
      let url = "device-monitor/result/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    },
    fetchCloudEnvs() {
      this.$http["get"](
        "cloud/env/", {}, (data) => {
          this.cloudEnvList = data.data.results.map(item => item.cloud);
        }
      );
    },
    fetchMonitorTasks() {
      this.$http["get"](
        "device-monitor/tasks/", {}, (data) => {
          this.monitorDevices = data.data.results.map(item => item.device_name);
        }
      );
    },
    fetchDeviceMonitorMetrics() {
      this.$http["get"](
        "device-monitor/metrics/", {}, (data) => {
          this.deviceMonitorMetricsList = data.data.results.map(item => item.metric);
        }
      );
    }
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
